module.exports = __webpack_public_path__ + "img/plug_halo.b16575bf.png";